import { gerarUUID } from "../../../util/uuid.utils"
import { tipoInputPadraoEnum } from "../enum/TipoInput.enum"

export const camposPadraoEmpresa = [
    {
      tipoInput: tipoInputPadraoEnum.NOME_FANTASIA.getKey(),
      blocoPadrao: tipoInputPadraoEnum.NOME_FANTASIA.getId(),
      uuid: gerarUUID()
    },
    {
      tipoInput: tipoInputPadraoEnum.SUGESTOES_NOME_EMPRESARIAL.getKey(),
      blocoPadrao: tipoInputPadraoEnum.SUGESTOES_NOME_EMPRESARIAL.getId(),
      uuid: gerarUUID()
    },
    {
      tipoInput: tipoInputPadraoEnum.ENDERECO_EMPRESA.getKey(),
      blocoPadrao: tipoInputPadraoEnum.ENDERECO_EMPRESA.getId(),
      uuid: gerarUUID()
    },
    {
      tipoInput: tipoInputPadraoEnum.IPTU_EMPRESA.getKey(),
      blocoPadrao: tipoInputPadraoEnum.IPTU_EMPRESA.getId(),
      uuid: gerarUUID()
    },
    {
      tipoInput: tipoInputPadraoEnum.DADOS_COMPLEMENTARES.getKey(),
      blocoPadrao: tipoInputPadraoEnum.DADOS_COMPLEMENTARES.getId(),
      uuid: gerarUUID()
    },
    {
      tipoInput: tipoInputPadraoEnum.ADICIONAR_SOCIO.getKey(),
      blocoPadrao: tipoInputPadraoEnum.ADICIONAR_SOCIO.getId(),
      uuid: gerarUUID()
    },
    {
      tipoInput: tipoInputPadraoEnum.ANEXOS.getKey(),
      blocoPadrao: tipoInputPadraoEnum.ANEXOS.getId(),
      uuid: gerarUUID()
    }
]

export const camposPadraoSocio = [
    {
      tipoInput: tipoInputPadraoEnum.DADOS_SOCIO.getKey(),
      blocoPadrao: tipoInputPadraoEnum.DADOS_SOCIO.getId(),
      uuid: gerarUUID(),
      isCampoSocio: true,
    },
    {
      tipoInput: tipoInputPadraoEnum.DADOS_COMPLEMENTARES_SOCIO.getKey(),
      blocoPadrao: tipoInputPadraoEnum.DADOS_COMPLEMENTARES_SOCIO.getId(),
      uuid: gerarUUID(),
      isCampoSocio: true
    },
    {
      tipoInput: tipoInputPadraoEnum.TIPO_SOCIO.getKey(),
      blocoPadrao: tipoInputPadraoEnum.TIPO_SOCIO.getId(),
      uuid: gerarUUID(),
      isCampoSocio: true
    },
    {
      tipoInput: tipoInputPadraoEnum.ENDERECO_SOCIO.getKey(),
      blocoPadrao: tipoInputPadraoEnum.ENDERECO_SOCIO.getId(),
      uuid: gerarUUID(),
      isCampoSocio: true
    },
    {
      tipoInput: tipoInputPadraoEnum.INFORMACOES_CONTATO.getKey(),
      blocoPadrao: tipoInputPadraoEnum.INFORMACOES_CONTATO.getId(),
      uuid: gerarUUID(),
      isCampoSocio: true
    }
]